import { prefersReducedMotion } from '@oo/theme';

// Reiter nach dem WAI-ARIA-Tabs-Muster. Ohne dieses Script stehen alle Reiter-Inhalte untereinander.
class OoTabs extends HTMLElement {
  connectedCallback() {
    this.tablist = this.querySelector('[role="tablist"]');
    this.tabs = [...this.querySelectorAll('[role="tab"]')];
    this.panels = this.tabs.map((tab) => document.getElementById(tab.getAttribute('aria-controls')));
    if (!this.tablist || this.tabs.length < 2 || this.panels.includes(null)) return;

    this.moreLinks = [...this.querySelectorAll('[data-oo-tab-more]')];
    this.panels.forEach((panel, index) => {
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', this.tabs[index].id);
    });

    this.onClick = (event) => {
      const tab = event.target.closest('[role="tab"]');
      if (tab) {
        this.select(tab);
        this.reveal(tab);
      }
    };
    this.onKeydown = (event) => this.handleKey(event);
    // Im Theme-Editor den Reiter zeigen, dessen Block gerade ausgewählt ist.
    this.onBlockSelect = (event) => {
      const index = this.panels.findIndex((panel) => panel.contains(event.target));
      if (index > -1) this.select(this.tabs[index]);
    };

    this.tablist.addEventListener('click', this.onClick);
    this.tablist.addEventListener('keydown', this.onKeydown);
    this.addEventListener('shopify:block:select', this.onBlockSelect);

    const current = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
    this.select(current);
  }

  disconnectedCallback() {
    this.tablist?.removeEventListener('click', this.onClick);
    this.tablist?.removeEventListener('keydown', this.onKeydown);
    this.removeEventListener('shopify:block:select', this.onBlockSelect);
  }

  select(activeTab, moveFocus = false) {
    this.tabs.forEach((tab, index) => {
      const active = tab === activeTab;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
      this.panels[index].hidden = !active;
      this.panels[index].classList.toggle('is-active', active);
    });
    const panelId = activeTab.getAttribute('aria-controls');
    this.moreLinks.forEach((link) => {
      link.hidden = link.dataset.ooTabMore !== panelId;
    });
    if (moveFocus) activeTab.focus();
  }

  // In der Wischleiste (Handy, ab fünf Reitern, oo-shop-tabs.css) den gewählten Reiter ganz ins Bild holen.
  // Nur die Leiste scrollt, die Seite bleibt stehen.
  reveal(tab) {
    const list = this.tablist;
    if (list.scrollWidth <= list.clientWidth) return;
    const box = list.getBoundingClientRect();
    const rect = tab.getBoundingClientRect();
    let offset = 0;
    if (rect.left < box.left) offset = rect.left - box.left - 8;
    else if (rect.right > box.right) offset = rect.right - box.right + 24;
    if (!offset) return;
    // Wie die Bilderleiste der Produktseite: auch die Theme-Einstellung „Bewegung“ zählt, nicht nur das System
    list.scrollBy({ left: offset, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
  }

  handleKey(event) {
    const index = this.tabs.indexOf(event.target);
    if (index === -1) return;
    const last = this.tabs.length - 1;
    let next;
    switch (event.key) {
      case 'ArrowRight':
        next = index === last ? 0 : index + 1;
        break;
      case 'ArrowLeft':
        next = index === 0 ? last : index - 1;
        break;
      case 'Home':
        next = 0;
        break;
      case 'End':
        next = last;
        break;
      default:
        return;
    }
    event.preventDefault();
    this.select(this.tabs[next], true);
    this.reveal(this.tabs[next]);
  }
}

if (!customElements.get('oo-tabs')) customElements.define('oo-tabs', OoTabs);
